// // import React, { useEffect, useRef } from "react";
// // import {
// //   Paper,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TablePagination,
// //   TableRow,
// //   Collapse,
// //   IconButton,
// //   Typography,
// //   Chip,
// //   Box,
// //   Tooltip,
// // } from "@mui/material";
// // import { useState } from "react";
// // import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// // import moment from "moment";
// // import { useLocation, useNavigate, useParams } from "react-router-dom";
// // import dayjs from "dayjs";
// // import axios from "axios";
// // import { FISH_FEED_OUTGOING_CALL } from "../../../constants";
// // import CallIcon from "@mui/icons-material/Call";
// // import PlayArrowIcon from "@mui/icons-material/PlayArrow";

// // function ConnectedCallTable({
// //   filters,
// //   setFilters,
// //   setMetricData,
// //   setLoading,
// // }) {
// //   const empDetails = JSON.parse(localStorage.getItem("userData"));

// //   const navigate = useNavigate();

// //   const location = useLocation();
// //   const { prevFilters } = location.state || {}; // Access prevFilters from state
// //   const [page, setPage] = useState(0); // Current page
// //   const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
// //   const [totalCount, setTotalCount] = useState(0);
// //   const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded

// //   const { agentName, agentNo } = useParams();

// //   const [callData, setCallData] = useState([]);

// //   const isInitialLoad = useRef(true);

// //   const fetchConnectedData = () => {
// //     const { startDate, endDate } = filters;

// //     // Determine yesterday's date
// //     const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

// //     // Format startDate and endDate, defaulting to yesterday if not provided
// //     const formattedStartDate = startDate
// //       ? dayjs(startDate).format("YYYY-MM-DD")
// //       : yesterday;
// //     const formattedEndDate = endDate
// //       ? dayjs(endDate).format("YYYY-MM-DD")
// //       : yesterday;

// //     // Build query params
// //     const queryParams = new URLSearchParams();
// //     queryParams.append("startDate", formattedStartDate);
// //     queryParams.append("endDate", formattedEndDate);
// //     if (localStorage.getItem("empRole") === "300") {
// //       queryParams.append("agentNumber", empDetails.EmployeePhone);
// //     } else {
// //       queryParams.append("agentNumber", agentNo);
// //     }
// //     queryParams.append("callStatus", "Connected");
// //     queryParams.append("page", page + 1); // Current page (1-based index)
// //     queryParams.append("pageSize", rowsPerPage); // Number of rows per page
// //     setLoading(true);
// //     axios
// //       .get(`${FISH_FEED_OUTGOING_CALL}?${queryParams.toString()}`)
// //       .then((response) => {
// //         const { connected, pagination, summary } = response.data;

// //         setCallData(connected.calls); // Update the call data
// //         setTotalCount(pagination.totalRecords); // Update the total record count
// //         setMetricData(summary);
// //         setLoading(false);
// //       })
// //       .catch((error) => {
// //         console.error("Error fetching connected data:", error);
// //         setCallData([]); // Set call data to empty on error
// //         setLoading(false);
// //       });
// //   };

// //   // Initialize filters with prevFilters
// //   useEffect(() => {
// //     if (localStorage.getItem("empRole") === "301") {
// //       if (prevFilters) {
// //         console.log("Applying prevFilters:", prevFilters);
// //         setFilters(prevFilters);
// //       } else {
// //         // Default to the last 7 days
// //         setFilters({
// //           startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"),
// //           endDate: dayjs().format("YYYY-MM-DD"),
// //         });
// //       }
// //       isInitialLoad.current = false; // Mark initial load as complete
// //     }
// //   }, [prevFilters]);

// //   // Fetch data when filters, page, or rowsPerPage change
// //   useEffect(() => {
// //     if (localStorage.getItem("empRole") === "301") {
// //       if (isInitialLoad.current || !filters.startDate || !filters.endDate) {
// //         return; // Skip if it's the initial load or filters are incomplete
// //       }
// //       console.log("Fetching data with filters:", filters);
// //       fetchConnectedData();
// //     }
// //   }, [filters, page, rowsPerPage]);

// //   useEffect(() => {
// //     if (localStorage.getItem("empRole") === "300") {
// //       fetchConnectedData();
// //     }
// //   }, [filters, page, rowsPerPage]);

// //   // Handle page change
// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage);
// //   };

// //   // Handle rows per page change
// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10));
// //     setPage(0); // Reset to the first page
// //   };

// //   // Handle row expansion toggle
// //   const handleRowToggle = (index) => {
// //     setOpenRows((prev) => {
// //       if (prev.includes(index)) {
// //         return prev.filter((rowIndex) => rowIndex !== index);
// //       } else {
// //         return [...prev, index];
// //       }
// //     });
// //   };

// //   const formatDate = (dateString) =>
// //     moment(dateString).format("DD-MM-YYYY HH:mm:ss");

// //   const IconCell = ({ row }) => (
// //     <>
// //       <Tooltip title="Call" arrow>
// //         <IconButton
// //           style={{
// //             border: "1px solid",
// //             borderRadius: "4px",
// //             padding: "2px",
// //             width: "24px",
// //             height: "24px",
// //             justifyContent: "center",
// //             alignItems: "center",
// //             backgroundColor: "#fff",
// //           }}
// //           color="primary"
// //           onClick={() => handleCallIconClick(row)}
// //         >
// //           <CallIcon fontSize="small" color="primary" />
// //         </IconButton>
// //       </Tooltip>
// //     </>
// //   );

// //   const handleCallIconClick = (row) => {
// //     navigate("/dashboard", {
// //       state: {
// //         mobNo: row.customerNumber,
// //         lotNum: row.customerNumber,
// //       },
// //     });
// //   };

// //   const handlePlayRecording = (url) => {
// //     if (url) {
// //       window.open(url, "_blank", "noopener,noreferrer");
// //     } else {
// //       alert("No recording URL available.");
// //     }
// //   };

// //   return (
// //     <>
// //       <Paper>
// //         <TableContainer component={Paper} elevation={3}>
// //           <Table
// //             sx={{
// //               minWidth: 650,
// //               height: "100%",
// //               tableLayout: "fixed",
// //             }}
// //             aria-label="simple table"
// //           >
// //             <TableHead>
// //               <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
// //                 <TableCell width={50} sx={{ textAlign: "center" }} />
// //                 <TableCell
// //                   width={50}
// //                   sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
// //                 >
// //                   SNo
// //                 </TableCell>

// //                 <TableCell
// //                   width={150}
// //                   sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
// //                 >
// //                   Mobile Number
// //                 </TableCell>
// //                 <TableCell
// //                   width={150}
// //                   sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
// //                 >
// //                   Dealer Name
// //                 </TableCell>
// //                 <TableCell
// //                   width={150}
// //                   sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
// //                 >
// //                   Region
// //                 </TableCell>
// //                 <TableCell
// //                   width={150}
// //                   sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
// //                 >
// //                   Farmer Type
// //                 </TableCell>
// //                 <TableCell
// //                   width={150}
// //                   sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
// //                 >
// //                   Postal Code
// //                 </TableCell>
// //                 <TableCell
// //                   width={150}
// //                   sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
// //                 >
// //                   Status
// //                 </TableCell>
// //                 <TableCell
// //                   width={120}
// //                   sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
// //                 >
// //                   Duration (Minutes)
// //                 </TableCell>
// //                 <TableCell
// //                   align="center"
// //                   sx={{
// //                     fontWeight: "bold",
// //                     textAlign: "center",
// //                     width: "80px",
// //                     position: "sticky", // Make the cell sticky
// //                     right: 0, // Fix to the right side
// //                     backgroundColor: "#EEF0F4", // Set background color for visibility
// //                     zIndex: 100, // Higher z-index to stay above other cells
// //                     boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
// //                     top: 0,
// //                   }}
// //                 >
// //                   Action
// //                 </TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {Array.isArray(callData) && callData.length > 0 ? (
// //                 callData.map((row, rowIndex) => (
// //                   <React.Fragment key={rowIndex}>
// //                     <TableRow
// //                       sx={{
// //                         "&:hover": { backgroundColor: "#f9f9f9" },
// //                       }}
// //                     >
// //                       <TableCell>
// //                         <IconButton
// //                           onClick={() => handleRowToggle(rowIndex)}
// //                           sx={{ padding: 0 }}
// //                         >
// //                           <ExpandMoreIcon />
// //                         </IconButton>
// //                       </TableCell>
// //                       <TableCell width={50} sx={{ textAlign: "center" }}>
// //                         {page * rowsPerPage + rowIndex + 1}
// //                       </TableCell>
// //                       {/* <TableCell width={160} sx={{ textAlign: "center" }}>
// //                           {row.customer_details === null
// //                             ? "New Customer"
// //                             : row.customer_details?.farmer_name}
// //                         </TableCell> */}
// //                       <TableCell width={150} sx={{ textAlign: "center" }}>
// //                         {row.customerNumber || "-"}
// //                       </TableCell>
// //                       <TableCell width={150} sx={{ textAlign: "center" }}>
// //                         {row.customerDetails?.dealerName || "-"}
// //                       </TableCell>
// //                       <TableCell width={150} sx={{ textAlign: "center" }}>
// //                         {row.customerDetails?.region || "-"}
// //                       </TableCell>

// //                       <TableCell width={150} sx={{ textAlign: "center" }}>
// //                         {row.customerDetails?.farmerType || "-"}
// //                       </TableCell>
// //                       <TableCell width={150} sx={{ textAlign: "center" }}>
// //                         {row.customerDetails?.postalCode || "-"}
// //                       </TableCell>
// //                       <TableCell width={150} sx={{ textAlign: "center" }}>
// //                         <Chip
// //                           label={
// //                             row.customerDetails?.status === "open"
// //                               ? "Open"
// //                               : "Closed"
// //                           }
// //                           color={
// //                             row.customerDetails?.status === "open"
// //                               ? "error"
// //                               : "success"
// //                           }
// //                           size="small"
// //                           sx={{ textTransform: "capitalize", margin: "5px" }}
// //                         />
// //                       </TableCell>

// //                       <TableCell
// //                         width={120}
// //                         sx={{
// //                           textAlign: "center",
// //                           textTransform: "capitalize",
// //                         }}
// //                       >
// //                         {row.callDuration || "-"}
// //                       </TableCell>
// //                       <TableCell
// //                         align="center"
// //                         sx={{
// //                           width: "80px",
// //                           padding: 1,
// //                           position: "sticky", // Make the cell sticky
// //                           right: 0, // Fix to the right side
// //                           backgroundColor: "#EEF0F4", // Set background color for visibility
// //                           zIndex: 10, // Higher z-index to stay above other cells
// //                           boxShadow: "0 2px 5px rgba(0,0,0,0.1)", // Add a shadow to the column
// //                         }}
// //                       >
// //                         <Box
// //                           sx={{
// //                             display: "flex", // Flex layout for icon buttons
// //                             gap: "4px", // Add gap between buttons
// //                             justifyContent: "flex-start", // Center align buttons horizontally
// //                             alignItems: "flex-start", // Center align buttons vertically
// //                             padding: "4px", // Optional padding around the group
// //                           }}
// //                         >
// //                           {row.customerDetails?.status === "open" && (
// //                             <IconCell row={row} />
// //                           )}

// //                           {row.recordingUrl ? (
// //                             <Tooltip title="Recording" arrow>
// //                               <IconButton
// //                                 sx={{
// //                                   border: "1px solid",
// //                                   borderRadius: "4px",
// //                                   padding: "2px",
// //                                   width: "24px",
// //                                   height: "24px",
// //                                   justifyContent: "center",
// //                                   alignItems: "center",
// //                                   transition: "color 0.3s",
// //                                   "&:hover": { color: "#0B9B73" },
// //                                   backgroundColor: "#fff",
// //                                 }}
// //                                 color="primary"
// //                                 onClick={() =>
// //                                   handlePlayRecording(row.recordingUrl)
// //                                 }
// //                               >
// //                                 <PlayArrowIcon />
// //                               </IconButton>
// //                             </Tooltip>
// //                           ) : (
// //                             <Typography variant="caption" color="textSecondary">
// //                               No Recording
// //                             </Typography>
// //                           )}
// //                         </Box>
// //                       </TableCell>
// //                     </TableRow>
// //                     <TableRow>
// //                       <TableCell
// //                         colSpan={10}
// //                         sx={{ paddingBottom: 0, paddingTop: 0 }}
// //                       >
// //                         <Collapse
// //                           in={openRows.includes(rowIndex)}
// //                           timeout="auto"
// //                           unmountOnExit
// //                         >
// //                           <Paper sx={{ padding: 2 }}>
// //                             <Typography variant="h6">
// //                               Customer Details
// //                             </Typography>
// //                             <Typography>
// //                               <strong>Connected On:</strong> {row.callStartDate}
// //                             </Typography>
// //                             <Typography>
// //                               <strong>Connected At:</strong>{" "}
// //                               {row.callStartTime === null
// //                                 ? "-"
// //                                 : row.callStartTime}
// //                             </Typography>

// //                             <Typography>
// //                               <strong>Farmer Village:</strong>{" "}
// //                               {row.customerDetails?.farmerVillage || "-"}
// //                             </Typography>
// //                             <Typography>
// //                               <strong>State:</strong>{" "}
// //                               {row.customerDetails?.state || "-"}
// //                             </Typography>
// //                             <Typography>
// //                               <strong>Shrimp Zone:</strong>{" "}
// //                               {row.customerDetails?.shrimpZone || "-"}
// //                             </Typography>
// //                             <Typography>
// //                               <strong>Dealer Code:</strong>{" "}
// //                               {row.customerDetails?.dealerCode || "-"}
// //                             </Typography>
// //                             <Typography>
// //                               <strong>Remarks:</strong>{" "}
// //                               {row.customerDetails?.remarks || "-"}
// //                             </Typography>
// //                             <Typography>
// //                               <strong>Feed Type:</strong>{" "}
// //                               {row.customerDetails?.feedType || "-"}
// //                             </Typography>
// //                             <Typography>
// //                               <strong>Last Action Date:</strong>{" "}
// //                               {formatDate(row.customerDetails?.lastActionDate) || "-"}
// //                             </Typography>

// //                             {/* Feed Remarks Section */}
// //                             <Typography variant="h6" sx={{ mt: 2 }}>
// //                               Feed Remarks
// //                             </Typography>
// //                             {Array.isArray(row.customerDetails?.feedRemarks) && row.customerDetails.feedRemarks.length > 0 ? (
// //                               row.customerDetails.feedRemarks.map((remark, idx) => (
// //                                 <Paper key={remark.id || idx} sx={{ p: 1, mb: 1, background: "#f5f5f5" }}>
// //                                   <Typography>
// //                                     <strong>Name:</strong> {remark.name || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Type:</strong> {remark.type || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Pond Location:</strong> {remark.pondLocation || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Category:</strong> {remark.prospectFarmerCategory || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>District:</strong> {remark.district || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Current Feed Used:</strong> {remark.currentFeedUsed || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Fish Species:</strong> {remark.fishSpecies || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Number of Ponds:</strong> {remark.numberOfPonds || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Area of Ponds(in acres):</strong> {remark.pondAreaInAcres || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Stocking(Yes/No):</strong> {remark.isStocking || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Stocking Density:</strong> {remark.stockingDensity || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Days of Culture:</strong> {remark.daysOfCulture || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Harvesting(Yes/No):</strong> {remark.isHarvesting || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Harvesting Quantity:</strong> {remark.harvestingQuantity || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Potential(in MT):</strong> {remark.potentialityInMT || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Status:</strong> {remark.status || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Purpose:</strong> {remark.purpose || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Agent Remarks:</strong> {remark.agentRemarks || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Call Type:</strong> {remark.callType || "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>FollowUp Date:</strong> {remark.followUpDate ? moment(remark.followUpDate).format("DD-MM-YYYY HH:mm:ss") : "-"}
// //                                   </Typography>
// //                                   <Typography>
// //                                     <strong>Created At:</strong> {remark.createdAt ? moment(remark.createdAt).format("DD-MM-YYYY HH:mm:ss") : "-"}
// //                                   </Typography>
// //                                 </Paper>
// //                               ))
// //                             ) : (
// //                               <Typography>No feed remarks available.</Typography>
// //                             )}

// //                           </Paper>
// //                         </Collapse>
// //                       </TableCell>
// //                     </TableRow>
// //                   </React.Fragment>
// //                 ))
// //               ) : (
// //                 <TableRow>
// //                   <TableCell colSpan={5} align="left">
// //                     No details available yet.
// //                   </TableCell>
// //                 </TableRow>
// //               )}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //         <TablePagination
// //           rowsPerPageOptions={[5, 10, 25]} // Options for rows per page
// //           component="div"
// //           count={totalCount} // Total number of rows
// //           rowsPerPage={rowsPerPage} // Current rows per page
// //           page={page} // Current page
// //           onPageChange={handleChangePage} // Handle page change
// //           onRowsPerPageChange={handleChangeRowsPerPage} // Handle rows per page change
// //         />
// //       </Paper>
// //     </>
// //   );
// // }

// // export default ConnectedCallTable;

// import React, { useEffect, useRef } from "react";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Collapse,
//   IconButton,
//   Typography,
//   Chip,
//   Box,
//   Tooltip,
//   Divider,
//   Card,
//   CardContent,
//   Grid,
//   Button,
// } from "@mui/material";
// import { useState } from "react";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import PhoneIcon from "@mui/icons-material/Phone";
// import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
// import PersonIcon from "@mui/icons-material/Person";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import TimerIcon from "@mui/icons-material/Timer";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import CommentIcon from "@mui/icons-material/Comment";
// import BusinessIcon from "@mui/icons-material/Business";
// import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
// import moment from "moment";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import dayjs from "dayjs";
// import axios from "axios";
// import { FISH_FEED_OUTGOING_CALL } from "../../../constants";
// import CallIcon from "@mui/icons-material/Call";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";

// function ConnectedCallTable({
//   filters,
//   setFilters,
//   setMetricData,
//   setLoading,
// }) {
//   const empDetails = JSON.parse(localStorage.getItem("userData"));

//   const navigate = useNavigate();

//   const location = useLocation();
//   const { prevFilters } = location.state || {}; // Access prevFilters from state
//   const [page, setPage] = useState(0); // Current page
//   const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
//   const [totalCount, setTotalCount] = useState(0);
//   const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded

//   const { agentName, agentNo } = useParams();

//   const [callData, setCallData] = useState([]);

//   const isInitialLoad = useRef(true);

//   const fetchConnectedData = () => {
//     const { startDate, endDate } = filters;

//     // Determine yesterday's date
//     const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

//     // Format startDate and endDate, defaulting to yesterday if not provided
//     const formattedStartDate = startDate
//       ? dayjs(startDate).format("YYYY-MM-DD")
//       : yesterday;
//     const formattedEndDate = endDate
//       ? dayjs(endDate).format("YYYY-MM-DD")
//       : yesterday;

//     // Build query params
//     const queryParams = new URLSearchParams();
//     queryParams.append("startDate", formattedStartDate);
//     queryParams.append("endDate", formattedEndDate);
//     // ###############################################################
//     // ###############################################################
//     // ###############################################################
//     if (localStorage.getItem("empRole") === "300") {
//       queryParams.append("agentNumber", empDetails?.EmployeePhone);
//     } else {
//       queryParams.append("agentNumber", 7880162561); // Default agent number (Pollai Hari)
//     }
//     // ###############################################################
//     // ###############################################################
//     // ###############################################################
//     queryParams.append("callStatus", "Connected");
//     queryParams.append("page", page + 1); // Current page (1-based index)
//     queryParams.append("pageSize", rowsPerPage); // Number of rows per page
//     setLoading(true);
//     axios
//       .get(`${FISH_FEED_OUTGOING_CALL}?${queryParams.toString()}`)
//       .then((response) => {
//         const { connected, pagination, summary } = response.data;

//         setCallData(connected.calls); // Update the call data
//         setTotalCount(pagination.totalRecords); // Update the total record count
//         setMetricData(summary);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching connected data:", error);
//         setCallData([]); // Set call data to empty on error
//         setLoading(false);
//       });
//   };

//   // Initialize filters with prevFilters
//   useEffect(() => {
//     if (localStorage.getItem("empRole") === "301") {
//       if (prevFilters) {
//         console.log("Applying prevFilters:", prevFilters);
//         setFilters(prevFilters);
//       } else {
//         // Default to the last 7 days
//         setFilters({
//           startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"),
//           endDate: dayjs().format("YYYY-MM-DD"),
//         });
//       }
//       isInitialLoad.current = false; // Mark initial load as complete
//     }
//   }, [prevFilters]);

//   // Fetch data when filters, page, or rowsPerPage change
//   useEffect(() => {
//     if (localStorage.getItem("empRole") === "301") {
//       if (isInitialLoad.current || !filters.startDate || !filters.endDate) {
//         return; // Skip if it's the initial load or filters are incomplete
//       }
//       console.log("Fetching data with filters:", filters);
//       fetchConnectedData();
//     }
//   }, [filters, page, rowsPerPage]);

//   useEffect(() => {
//     if (localStorage.getItem("empRole") === "300" || localStorage.getItem("empRole") === "301") {
//       fetchConnectedData();
//     }
//   }, [filters, page, rowsPerPage]);

//   // Handle page change
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   // Handle rows per page change
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0); // Reset to the first page
//   };

//   // Handle row expansion toggle
//   const handleRowToggle = (index) => {
//     setOpenRows((prev) => {
//       if (prev.includes(index)) {
//         return prev.filter((rowIndex) => rowIndex !== index);
//       } else {
//         return [...prev, index];
//       }
//     });
//   };

//   const formatDate = (dateString) =>
//     moment(dateString).format("DD-MM-YYYY HH:mm:ss");

//   const IconCell = ({ row }) => (
//     <Button
//       variant="contained"
//       size="small"
//       startIcon={<CallIcon />}
//       onClick={() => handleCallIconClick(row)}
//       sx={{
//         minWidth: 'auto',
//         px: 1.5,
//         py: 0.5,
//         borderRadius: 2,
//         fontSize: '0.75rem',
//         fontWeight: 600,
//         textTransform: 'none',
//         boxShadow: 1,
//         '&:hover': {
//           boxShadow: 2,
//           transform: 'translateY(-1px)',
//         },
//         transition: 'all 0.2s ease',
//       }}
//     >
//       Call
//     </Button>
//   );

//   const handleCallIconClick = (row) => {
//     navigate("/dashboard", {
//       state: {
//         mobNo: row.customerNumber,
//         lotNum: row.customerNumber,
//       },
//     });
//   };

//   const handlePlayRecording = (url) => {
//     if (url) {
//       window.open(url, "_blank", "noopener,noreferrer");
//     } else {
//       alert("No recording URL available.");
//     }
//   };

//   const getDurationColor = (duration) => {
//     if (!duration || duration === "-") return "default";
//     const durationNum = parseFloat(duration);
//     if (durationNum < 2) return "error";
//     if (durationNum < 5) return "warning";
//     return "success";
//   };

//   const InfoItem = ({ icon, label, value }) => (
//     <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
//       <Box sx={{
//         display: 'flex',
//         alignItems: 'center',
//         minWidth: 140,
//         color: 'text.secondary',
//         fontSize: '0.875rem',
//         fontWeight: 500
//       }}>
//         {icon}
//         <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
//           {label}:
//         </Typography>
//       </Box>
//       <Typography variant="body2" sx={{ ml: 1, fontWeight: 400 }}>
//         {value || "-"}
//       </Typography>
//     </Box>
//   );

//   return (
//     <>
//       <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//         <TableContainer component={Paper} elevation={0}>
//           <Table
//             sx={{
//               minWidth: 650,
//               height: "100%",
//               tableLayout: "fixed",
//             }}
//             aria-label="outgoing connected calls table"
//           >
//             <TableHead>
//               <TableRow sx={{
//                 backgroundColor: "success.main",
//                 '& .MuiTableCell-head': {
//                   color: 'white',
//                   fontWeight: 600,
//                   fontSize: '0.875rem',
//                 }
//               }}>
//                 <TableCell width={60} sx={{ textAlign: "center" }} />
//                 <TableCell
//                   width={60}
//                   sx={{ textAlign: "center", padding: 2 }}
//                 >
//                   S.No
//                 </TableCell>
//                 <TableCell
//                   width={150}
//                   sx={{ textAlign: "center", padding: 2 }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <PhoneCallbackIcon sx={{ mr: 1, fontSize: 18 }} />
//                     Mobile Number
//                   </Box>
//                 </TableCell>
//                 <TableCell
//                   width={150}
//                   sx={{ textAlign: "center", padding: 2 }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
//                     Dealer Name
//                   </Box>
//                 </TableCell>
//                 <TableCell
//                   width={120}
//                   sx={{ textAlign: "center", padding: 2 }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <LocationOnIcon sx={{ mr: 1, fontSize: 18 }} />
//                     Region
//                   </Box>
//                 </TableCell>
//                 <TableCell
//                   width={120}
//                   sx={{ textAlign: "center", padding: 2 }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <BusinessIcon sx={{ mr: 1, fontSize: 18 }} />
//                     Farmer Type
//                   </Box>
//                 </TableCell>
//                 <TableCell
//                   width={100}
//                   sx={{ textAlign: "center", padding: 2 }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <LocationOnIcon sx={{ mr: 1, fontSize: 18 }} />
//                     Postal Code
//                   </Box>
//                 </TableCell>
//                 <TableCell
//                   width={100}
//                   sx={{ textAlign: "center", padding: 2 }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <CommentIcon sx={{ mr: 1, fontSize: 18 }} />
//                     Status
//                   </Box>
//                 </TableCell>
//                 <TableCell
//                   width={120}
//                   sx={{ textAlign: "center", padding: 2 }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <TimerIcon sx={{ mr: 1, fontSize: 18 }} />
//                     Duration (Min)
//                   </Box>
//                 </TableCell>
//                 <TableCell
//                   align="center"
//                   sx={{
//                     textAlign: "center",
//                     width: "120px",
//                     position: "sticky",
//                     right: 0,
//                     backgroundColor: "success.main",
//                     zIndex: 100,
//                     boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
//                     padding: 2,
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <CallIcon sx={{ mr: 1, fontSize: 18 }} />
//                     Action
//                   </Box>
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {Array.isArray(callData) && callData.length > 0 ? (
//                 callData.map((row, rowIndex) => (
//                   <React.Fragment key={rowIndex}>
//                     <TableRow
//                       sx={{
//                         "&:hover": { backgroundColor: "action.hover" },
//                         backgroundColor: rowIndex % 2 === 0 ? "grey.50" : "white",
//                         transition: 'background-color 0.2s ease',
//                       }}
//                     >
//                       <TableCell sx={{ padding: 1 }}>
//                         <IconButton
//                           onClick={() => handleRowToggle(rowIndex)}
//                           sx={{
//                             padding: 1,
//                             transition: 'transform 0.2s ease',
//                             '&:hover': {
//                               backgroundColor: 'success.main',
//                               color: 'white',
//                               transform: 'scale(1.1)',
//                             }
//                           }}
//                         >
//                           {openRows.includes(rowIndex) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//                         </IconButton>
//                       </TableCell>
//                       <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
//                         <Chip
//                           label={page * rowsPerPage + rowIndex + 1}
//                           size="small"
//                           variant="outlined"
//                           color="success"
//                         />
//                       </TableCell>
//                       <TableCell sx={{ textAlign: "center", padding: 2, fontFamily: 'monospace' }}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                           <PhoneCallbackIcon sx={{ mr: 1, color: 'success.main', fontSize: 18 }} />
//                           {row.customerNumber || "-"}
//                         </Box>
//                       </TableCell>
//                       <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
//                         {row.customerDetails?.dealerName || "-"}
//                       </TableCell>
//                       <TableCell sx={{ textAlign: "center", padding: 2 }}>
//                         {row.customerDetails?.region || "-"}
//                       </TableCell>
//                       <TableCell sx={{ textAlign: "center", padding: 2 }}>
//                         {row.customerDetails?.farmerType || "-"}
//                       </TableCell>
//                       <TableCell sx={{ textAlign: "center", padding: 2 }}>
//                         {row.customerDetails?.postalCode || "-"}
//                       </TableCell>
//                       <TableCell sx={{ textAlign: "center", padding: 2 }}>
//                         <Chip
//                           label={
//                             row.customerDetails?.status === "open"
//                               ? "Open"
//                               : "Closed"
//                           }
//                           color={
//                             row.customerDetails?.status === "open"
//                               ? "error"
//                               : "success"
//                           }
//                           size="small"
//                           variant="filled"
//                           sx={{ textTransform: "capitalize" }}
//                         />
//                       </TableCell>
//                       <TableCell sx={{ textAlign: "center", padding: 2 }}>
//                         <Chip
//                           label={row.callDuration || "-"}
//                           size="small"
//                           color={getDurationColor(row.callDuration)}
//                           variant="filled"
//                         />
//                       </TableCell>
//                       <TableCell
//                         align="center"
//                         sx={{
//                           width: "120px",
//                           padding: 2,
//                           position: "sticky",
//                           right: 0,
//                           backgroundColor: rowIndex % 2 === 0 ? "grey.50" : "white",
//                           zIndex: 10,
//                           boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
//                           transition: 'background-color 0.2s ease',
//                         }}
//                       >
//                         <Box
//                           sx={{
//                             display: "flex",
//                             gap: 1,
//                             justifyContent: "center",
//                             alignItems: "center",
//                             flexWrap: 'wrap'
//                           }}
//                         >
//                           {row.customerDetails?.status === "open" && (
//                             <IconCell row={row} />
//                           )}

//                           {row.recordingUrl ? (
//                             <Tooltip title="Play Recording" arrow>
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 startIcon={<PlayArrowIcon />}
//                                 onClick={() => handlePlayRecording(row.recordingUrl)}
//                                 sx={{
//                                   minWidth: 'auto',
//                                   px: 1.5,
//                                   py: 0.5,
//                                   borderRadius: 2,
//                                   fontSize: '0.75rem',
//                                   fontWeight: 600,
//                                   textTransform: 'none',
//                                   '&:hover': {
//                                     transform: 'translateY(-1px)',
//                                   },
//                                   transition: 'all 0.2s ease',
//                                 }}
//                               >
//                                 Play
//                               </Button>
//                             </Tooltip>
//                           ) : (
//                             <Chip
//                               label="No Recording"
//                               size="small"
//                               variant="outlined"
//                               color="default"
//                               sx={{ fontSize: '0.7rem' }}
//                             />
//                           )}
//                         </Box>
//                       </TableCell>
//                     </TableRow>
//                     <TableRow>
//                       <TableCell
//                         colSpan={10}
//                         sx={{ paddingBottom: 0, paddingTop: 0, border: 0 }}
//                       >
//                         <Collapse
//                           in={openRows.includes(rowIndex)}
//                           timeout="auto"
//                           unmountOnExit
//                         >
//                           <Box sx={{ margin: 2 }}>
//                             <Card elevation={1} sx={{ borderRadius: 2 }}>
//                               <CardContent sx={{ p: 3 }}>
//                                 <Typography variant="h6" sx={{
//                                   mb: 2,
//                                   color: 'success.main',
//                                   fontWeight: 600,
//                                   display: 'flex',
//                                   alignItems: 'center'
//                                 }}>
//                                   <PersonIcon sx={{ mr: 1 }} />
//                                   Customer Details
//                                 </Typography>
//                                 <Divider sx={{ mb: 2 }} />

//                                 <Grid container spacing={3}>
//                                   <Grid item xs={12} md={6}>
//                                     <InfoItem
//                                       icon={<AccessTimeIcon fontSize="small" />}
//                                       label="Connected On"
//                                       value={row.callStartDate}
//                                     />
//                                     <InfoItem
//                                       icon={<AccessTimeIcon fontSize="small" />}
//                                       label="Connected At"
//                                       value={row.callStartTime}
//                                     />
//                                     <InfoItem
//                                       icon={<LocationOnIcon fontSize="small" />}
//                                       label="Farmer Village"
//                                       value={row.customerDetails?.farmerVillage}
//                                     />
//                                     <InfoItem
//                                       icon={<LocationOnIcon fontSize="small" />}
//                                       label="State"
//                                       value={row.customerDetails?.state}
//                                     />
//                                     <InfoItem
//                                       icon={<LocationOnIcon fontSize="small" />}
//                                       label="Shrimp Zone"
//                                       value={row.customerDetails?.shrimpZone}
//                                     />
//                                   </Grid>
//                                   <Grid item xs={12} md={6}>
//                                     <InfoItem
//                                       icon={<BusinessIcon fontSize="small" />}
//                                       label="Dealer Code"
//                                       value={row.customerDetails?.dealerCode}
//                                     />
//                                     <InfoItem
//                                       icon={<CommentIcon fontSize="small" />}
//                                       label="Remarks"
//                                       value={row.customerDetails?.remarks}
//                                     />
//                                     <InfoItem
//                                       icon={<CommentIcon fontSize="small" />}
//                                       label="Feed Type"
//                                       value={row.customerDetails?.feedType}
//                                     />
//                                     <InfoItem
//                                       icon={<AccessTimeIcon fontSize="small" />}
//                                       label="Last Action Date"
//                                       value={formatDate(row.customerDetails?.lastActionDate)}
//                                     />
//                                   </Grid>
//                                 </Grid>

//                                 <Typography variant="h6" sx={{
//                                   mt: 3,
//                                   mb: 2,
//                                   color: 'success.main',
//                                   fontWeight: 600,
//                                   display: 'flex',
//                                   alignItems: 'center'
//                                 }}>
//                                   <CommentIcon sx={{ mr: 1 }} />
//                                   Feed Remarks
//                                 </Typography>
//                                 <Divider sx={{ mb: 2 }} />

//                                 {Array.isArray(row.customerDetails?.feedRemarks) && row.customerDetails.feedRemarks.length > 0 ? (
//                                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                                     {row.customerDetails.feedRemarks.map((remark, idx) => (
//                                       <Card key={remark.id || idx} elevation={0} sx={{
//                                         backgroundColor: 'grey.50',
//                                         border: '1px solid',
//                                         borderColor: 'grey.200',
//                                         borderRadius: 2
//                                       }}>
//                                         <CardContent sx={{ p: 2 }}>
//                                           <Grid container spacing={2}>
//                                             <Grid item xs={12} md={6}>
//                                               <InfoItem label="Name" value={remark.name} />
//                                               <InfoItem label="Type" value={remark.type} />
//                                               <InfoItem label="Pond Location" value={remark.pondLocation} />
//                                               <InfoItem label="Category" value={remark.prospectFarmerCategory} />
//                                               <InfoItem label="District" value={remark.district} />
//                                               <InfoItem label="Current Feed Used" value={remark.currentFeedUsed} />
//                                               <InfoItem label="Fish Species" value={remark.fishSpecies} />
//                                               <InfoItem label="Number of Ponds" value={remark.numberOfPonds} />
//                                               <InfoItem label="Area of Ponds (acres)" value={remark.pondAreaInAcres} />
//                                               <InfoItem label="Stocking (Yes/No)" value={remark.isStocking} />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                               <InfoItem label="Stocking Density" value={remark.stockingDensity} />
//                                               <InfoItem label="Days of Culture" value={remark.daysOfCulture} />
//                                               <InfoItem label="Harvesting (Yes/No)" value={remark.isHarvesting} />
//                                               <InfoItem label="Harvesting Quantity" value={remark.harvestingQuantity} />
//                                               <InfoItem label="Potential (MT)" value={remark.potentialityInMT} />
//                                               <InfoItem label="Status" value={remark.status} />
//                                               <InfoItem label="Purpose" value={remark.purpose} />
//                                               <InfoItem label="Agent Remarks" value={remark.agentRemarks} />
//                                               <InfoItem label="Call Type" value={remark.callType} />
//                                               <InfoItem
//                                                 label="FollowUp Date"
//                                                 value={remark.followUpDate ? moment(remark.followUpDate).format("DD-MM-YYYY HH:mm:ss") : "-"}
//                                               />
//                                               <InfoItem
//                                                 label="Created At"
//                                                 value={remark.createdAt ? moment(remark.createdAt).format("DD-MM-YYYY HH:mm:ss") : "-"}
//                                               />
//                                             </Grid>
//                                           </Grid>
//                                         </CardContent>
//                                       </Card>
//                                     ))}
//                                   </Box>
//                                 ) : (
//                                   <Box sx={{
//                                     textAlign: 'center',
//                                     py: 3,
//                                     color: 'text.secondary',
//                                     backgroundColor: 'grey.50',
//                                     borderRadius: 2,
//                                     border: '1px dashed',
//                                     borderColor: 'grey.300'
//                                   }}>
//                                     <CommentIcon sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
//                                     <Typography variant="body1">No feed remarks available</Typography>
//                                   </Box>
//                                 )}
//                               </CardContent>
//                             </Card>
//                           </Box>
//                         </Collapse>
//                       </TableCell>
//                     </TableRow>
//                   </React.Fragment>
//                 ))
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={10} align="center" sx={{ py: 6 }}>
//                     <Box sx={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'center',
//                       color: 'text.secondary'
//                     }}>
//                       <PhoneCallbackIcon sx={{ fontSize: 64, mb: 2, opacity: 0.3, color: 'success.main' }} />
//                       <Typography variant="h6" sx={{ mb: 1 }}>No Outgoing Connected Calls</Typography>
//                       <Typography variant="body2">There are no outgoing connected calls to display for the selected period.</Typography>
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25]}
//           component="div"
//           count={totalCount}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//           sx={{
//             borderTop: '1px solid',
//             borderColor: 'divider',
//             backgroundColor: 'grey.50'
//           }}
//         />
//       </Paper>
//     </>
//   );
// }

// export default ConnectedCallTable;

import React, { useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Collapse,
  IconButton,
  Typography,
  Chip,
  Box,
  Tooltip,
  Divider,
  Card,
  CardContent,
  Grid,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TimerIcon from "@mui/icons-material/Timer";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CommentIcon from "@mui/icons-material/Comment";
import BusinessIcon from "@mui/icons-material/Business";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import { FISH_FEED_OUTGOING_CALL } from "../../../constants";
import CallIcon from "@mui/icons-material/Call";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

function ConnectedCallTable({
  filters,
  setFilters,
  setMetricData,
  setLoading,
}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const navigate = useNavigate();

  const location = useLocation();
  const { prevFilters } = location.state || {}; // Access prevFilters from state
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [totalCount, setTotalCount] = useState(0);
  const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded

  // Filter states
  const [mobileFilter, setMobileFilter] = useState("");
  const [stateFilter, setStateFilter] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const { agentName, agentNo } = useParams();

  const [callData, setCallData] = useState([]);

  const isInitialLoad = useRef(true);

  // State options for dropdown
  const stateOptions = [
    "AP", "OD", "TN", "RJ", "GJ", "HR", "PN",
    "KT", "WB", "CG"
  ];

  const fetchConnectedData = () => {
    const { startDate, endDate } = filters;

    // Determine yesterday's date
    const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

    // Format startDate and endDate, defaulting to yesterday if not provided
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : yesterday;
    const formattedEndDate = endDate
      ? dayjs(endDate).format("YYYY-MM-DD")
      : yesterday;

    // Build query params
    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);

    if (localStorage.getItem("empRole") === "300") {
      queryParams.append("agentNumber", empDetails?.EmployeePhone);
    } else {
      queryParams.append("agentNumber", 7880162561); // Default agent number (Pollai Hari)
    }

    queryParams.append("callStatus", "Connected");
    queryParams.append("page", page + 1); // Current page (1-based index)
    queryParams.append("pageSize", rowsPerPage); // Number of rows per page

    // Add filter parameters
    if (mobileFilter.trim()) {
      queryParams.append("bPartyNo", mobileFilter.trim());
    }
    if (stateFilter) {
      queryParams.append("state", stateFilter);
    }

    setLoading(true);
    axios
      .get(`${FISH_FEED_OUTGOING_CALL}?${queryParams.toString()}`)
      .then((response) => {
        const { connected, pagination, summary } = response.data;

        setCallData(connected.calls); // Update the call data
        setTotalCount(pagination.totalRecords); // Update the total record count
        setMetricData(summary);
        if ((page * rowsPerPage) >= pagination.totalRecords && page !== 0) {
          setPage(0);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching connected data:", error);
        setCallData([]); // Set call data to empty on error
        setLoading(false);
      });
  };

  // Initialize filters with prevFilters
  useEffect(() => {
    if (localStorage.getItem("empRole") === "301") {
      if (prevFilters) {
        console.log("Applying prevFilters:", prevFilters);
        setFilters(prevFilters);
      } else {
        // Default to the last 7 days
        setFilters({
          startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"),
          endDate: dayjs().format("YYYY-MM-DD"),
        });
      }
      isInitialLoad.current = false; // Mark initial load as complete
    }
  }, [prevFilters]);

  // Fetch data when filters, page, rowsPerPage, mobileFilter, or stateFilter change
  useEffect(() => {
    if (localStorage.getItem("empRole") === "301") {
      if (isInitialLoad.current || !filters.startDate || !filters.endDate) {
        return; // Skip if it's the initial load or filters are incomplete
      }
      console.log("Fetching data with filters:", filters);
      fetchConnectedData();
    }
  }, [filters, page, rowsPerPage, mobileFilter, stateFilter]);

  useEffect(() => {
    if (localStorage.getItem("empRole") === "300" || localStorage.getItem("empRole") === "301") {
      fetchConnectedData();
    }
  }, [filters, page, rowsPerPage, mobileFilter, stateFilter]);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  // Handle row expansion toggle
  const handleRowToggle = (index) => {
    setOpenRows((prev) => {
      if (prev.includes(index)) {
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  // Handle filter clear
  const handleClearFilters = () => {
    setMobileFilter("");
    setStateFilter("");
    setPage(0); // Reset to first page
  };

  // Handle mobile filter change
  const handleMobileFilterChange = (event) => {
    setMobileFilter(event.target.value);
    setPage(0); // Reset to first page when filter changes
  };

  // Handle state filter change
  const handleStateFilterChange = (event) => {
    setStateFilter(event.target.value);
    setPage(0); // Reset to first page when filter changes
  };

  const formatDate = (dateString) =>
    moment(dateString).format("DD-MM-YYYY HH:mm:ss");

  const IconCell = ({ row }) => (
    <Button
      variant="contained"
      size="small"
      startIcon={<CallIcon />}
      onClick={() => handleCallIconClick(row)}
      sx={{
        minWidth: 'auto',
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        fontSize: '0.75rem',
        fontWeight: 600,
        textTransform: 'none',
        boxShadow: 1,
        '&:hover': {
          boxShadow: 2,
          transform: 'translateY(-1px)',
        },
        transition: 'all 0.2s ease',
      }}
    >
      Call
    </Button>
  );

  const handleCallIconClick = (row) => {
    navigate("/dashboard", {
      state: {
        mobNo: row.customerNumber,
        lotNum: row.customerNumber,
      },
    });
  };

  const handlePlayRecording = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      alert("No recording URL available.");
    }
  };

  const getDurationColor = (duration) => {
    if (!duration || duration === "-") return "default";
    const durationNum = parseFloat(duration);
    if (durationNum < 2) return "error";
    if (durationNum < 5) return "warning";
    return "success";
  };

  const InfoItem = ({ icon, label, value }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        minWidth: 140,
        color: 'text.secondary',
        fontSize: '0.875rem',
        fontWeight: 500
      }}>
        {icon}
        <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
          {label}:
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ ml: 1, fontWeight: 400 }}>
        {value || "-"}
      </Typography>
    </Box>
  );

  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {/* Filter Section */}
        <Box sx={{ p: 2, backgroundColor: 'success.50', borderBottom: '1px solid', borderColor: 'divider' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: showFilters ? 2 : 0 }}>
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', fontWeight: 600 }}>
              <PhoneCallbackIcon sx={{ mr: 1, color: 'success.main' }} />
              Outgoing Connected Calls
            </Typography>
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setShowFilters(!showFilters)}
              size="small"
              color="success"
              sx={{ textTransform: 'none' }}
            >
              {showFilters ? 'Hide Filters' : 'Show Filters'}
            </Button>
          </Box>

          <Collapse in={showFilters}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <TextField
                label="Mobile Number"
                value={mobileFilter}
                onChange={handleMobileFilterChange}
                placeholder="Enter mobile number"
                size="small"
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                }}
                sx={{ minWidth: 200 }}
              />

              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>State</InputLabel>
                <Select
                  value={stateFilter}
                  onChange={handleStateFilterChange}
                  label="State"
                >
                  <MenuItem value="">
                    <em>All States</em>
                  </MenuItem>
                  {stateOptions.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {(mobileFilter || stateFilter) && (
                <Button
                  variant="outlined"
                  startIcon={<ClearIcon />}
                  onClick={handleClearFilters}
                  size="small"
                  color="error"
                  sx={{ textTransform: 'none' }}
                >
                  Clear Filters
                </Button>
              )}
            </Box>

            {/* Active filters display */}
            {(mobileFilter || stateFilter) && (
              <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary', mr: 1 }}>
                  Active Filters:
                </Typography>
                {mobileFilter && (
                  <Chip
                    label={`Mobile: ${mobileFilter}`}
                    size="small"
                    color="success"
                    variant="outlined"
                    onDelete={() => setMobileFilter("")}
                  />
                )}
                {stateFilter && (
                  <Chip
                    label={`State: ${stateFilter}`}
                    size="small"
                    color="success"
                    variant="outlined"
                    onDelete={() => setStateFilter("")}
                  />
                )}
              </Box>
            )}
          </Collapse>
        </Box>

        <TableContainer component={Paper} elevation={0}>
          <Table
            sx={{
              minWidth: 650,
              height: "100%",
              tableLayout: "fixed",
            }}
            aria-label="outgoing connected calls table"
          >
            <TableHead>
              <TableRow sx={{
                backgroundColor: "success.main",
                '& .MuiTableCell-head': {
                  color: 'white',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                }
              }}>
                <TableCell width={60} sx={{ textAlign: "center" }} />
                <TableCell
                  width={60}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  S.No
                </TableCell>
                <TableCell
                  width={150}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <PhoneCallbackIcon sx={{ mr: 1, fontSize: 18 }} />
                    Mobile Number
                  </Box>
                </TableCell>
                <TableCell
                  width={150}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
                    Dealer Name
                  </Box>
                </TableCell>
                <TableCell
                  width={120}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <LocationOnIcon sx={{ mr: 1, fontSize: 18 }} />
                    Region
                  </Box>
                </TableCell>
                <TableCell
                  width={120}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <BusinessIcon sx={{ mr: 1, fontSize: 18 }} />
                    Farmer Type
                  </Box>
                </TableCell>
                <TableCell
                  width={100}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <LocationOnIcon sx={{ mr: 1, fontSize: 18 }} />
                    Postal Code
                  </Box>
                </TableCell>
                <TableCell
                  width={100}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CommentIcon sx={{ mr: 1, fontSize: 18 }} />
                    Status
                  </Box>
                </TableCell>
                <TableCell
                  width={120}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <TimerIcon sx={{ mr: 1, fontSize: 18 }} />
                    Duration (Min)
                  </Box>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    textAlign: "center",
                    width: "120px",
                    position: "sticky",
                    right: 0,
                    backgroundColor: "success.main",
                    zIndex: 100,
                    boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
                    padding: 2,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CallIcon sx={{ mr: 1, fontSize: 18 }} />
                    Action
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(callData) && callData.length > 0 ? (
                callData.map((row, rowIndex) => (
                  <React.Fragment key={rowIndex}>
                    <TableRow
                      sx={{
                        "&:hover": { backgroundColor: "action.hover" },
                        backgroundColor: rowIndex % 2 === 0 ? "grey.50" : "white",
                        transition: 'background-color 0.2s ease',
                      }}
                    >
                      <TableCell sx={{ padding: 1 }}>
                        <IconButton
                          onClick={() => handleRowToggle(rowIndex)}
                          sx={{
                            padding: 1,
                            transition: 'transform 0.2s ease',
                            '&:hover': {
                              backgroundColor: 'success.main',
                              color: 'white',
                              transform: 'scale(1.1)',
                            }
                          }}
                        >
                          {openRows.includes(rowIndex) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                      </TableCell>
                      <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
                        <Chip
                          label={page * rowsPerPage + rowIndex + 1}
                          size="small"
                          variant="outlined"
                          color="success"
                        />
                      </TableCell>
                      <TableCell sx={{ textAlign: "center", padding: 2, fontFamily: 'monospace' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <PhoneCallbackIcon sx={{ mr: 1, color: 'success.main', fontSize: 18 }} />
                          {row.customerNumber || "-"}
                        </Box>
                      </TableCell>
                      <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
                        {row.customerDetails?.dealerName || "-"}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center", padding: 2 }}>
                        {row.customerDetails?.region || "-"}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center", padding: 2 }}>
                        {row.customerDetails?.farmerType || "-"}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center", padding: 2 }}>
                        {row.customerDetails?.postalCode || "-"}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center", padding: 2 }}>
                        <Chip
                          label={
                            row.customerDetails?.status === "open"
                              ? "Open"
                              : "Closed"
                          }
                          color={
                            row.customerDetails?.status === "open"
                              ? "error"
                              : "success"
                          }
                          size="small"
                          variant="filled"
                          sx={{ textTransform: "capitalize" }}
                        />
                      </TableCell>
                      <TableCell sx={{ textAlign: "center", padding: 2 }}>
                        <Chip
                          label={row.callDuration || "-"}
                          size="small"
                          color={getDurationColor(row.callDuration)}
                          variant="filled"
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: "120px",
                          padding: 2,
                          position: "sticky",
                          right: 0,
                          backgroundColor: rowIndex % 2 === 0 ? "grey.50" : "white",
                          zIndex: 10,
                          boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
                          transition: 'background-color 0.2s ease',
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexWrap: 'wrap'
                          }}
                        >
                          {row.customerDetails?.status === "open" && (
                            <IconCell row={row} />
                          )}

                          {row.recordingUrl ? (
                            <Tooltip title="Play Recording" arrow>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<PlayArrowIcon />}
                                onClick={() => handlePlayRecording(row.recordingUrl)}
                                sx={{
                                  minWidth: 'auto',
                                  px: 1.5,
                                  py: 0.5,
                                  borderRadius: 2,
                                  fontSize: '0.75rem',
                                  fontWeight: 600,
                                  textTransform: 'none',
                                  '&:hover': {
                                    transform: 'translateY(-1px)',
                                  },
                                  transition: 'all 0.2s ease',
                                }}
                              >
                                Play
                              </Button>
                            </Tooltip>
                          ) : (
                            <Chip
                              label="No Recording"
                              size="small"
                              variant="outlined"
                              color="default"
                              sx={{ fontSize: '0.7rem' }}
                            />
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={10}
                        sx={{ paddingBottom: 0, paddingTop: 0, border: 0 }}
                      >
                        <Collapse
                          in={openRows.includes(rowIndex)}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box sx={{ margin: 2 }}>
                            <Card elevation={1} sx={{ borderRadius: 2 }}>
                              <CardContent sx={{ p: 3 }}>
                                <Typography variant="h6" sx={{
                                  mb: 2,
                                  color: 'success.main',
                                  fontWeight: 600,
                                  display: 'flex',
                                  alignItems: 'center'
                                }}>
                                  <PersonIcon sx={{ mr: 1 }} />
                                  Customer Details
                                </Typography>
                                <Divider sx={{ mb: 2 }} />

                                <Grid container spacing={3}>
                                  <Grid item xs={12} md={6}>
                                    <InfoItem
                                      icon={<AccessTimeIcon fontSize="small" />}
                                      label="Connected On"
                                      value={row.callStartDate}
                                    />
                                    <InfoItem
                                      icon={<AccessTimeIcon fontSize="small" />}
                                      label="Connected At"
                                      value={row.callStartTime}
                                    />
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Farmer Village"
                                      value={row.customerDetails?.farmerVillage}
                                    />
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="State"
                                      value={row.customerDetails?.state}
                                    />
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Shrimp Zone"
                                      value={row.customerDetails?.shrimpZone}
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <InfoItem
                                      icon={<BusinessIcon fontSize="small" />}
                                      label="Dealer Code"
                                      value={row.customerDetails?.dealerCode}
                                    />
                                    <InfoItem
                                      icon={<CommentIcon fontSize="small" />}
                                      label="Remarks"
                                      value={row.customerDetails?.remarks}
                                    />
                                    <InfoItem
                                      icon={<CommentIcon fontSize="small" />}
                                      label="Feed Type"
                                      value={row.customerDetails?.feedType}
                                    />
                                    <InfoItem
                                      icon={<AccessTimeIcon fontSize="small" />}
                                      label="Last Action Date"
                                      value={formatDate(row.customerDetails?.lastActionDate)}
                                    />
                                  </Grid>
                                </Grid>

                                <Typography variant="h6" sx={{
                                  mt: 3,
                                  mb: 2,
                                  color: 'success.main',
                                  fontWeight: 600,
                                  display: 'flex',
                                  alignItems: 'center'
                                }}>
                                  <CommentIcon sx={{ mr: 1 }} />
                                  Feed Remarks
                                </Typography>
                                <Divider sx={{ mb: 2 }} />

                                {Array.isArray(row.customerDetails?.feedRemarks) && row.customerDetails.feedRemarks.length > 0 ? (
                                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    {row.customerDetails.feedRemarks.map((remark, idx) => (
                                      <Card key={remark.id || idx} elevation={0} sx={{
                                        backgroundColor: 'grey.50',
                                        border: '1px solid',
                                        borderColor: 'grey.200',
                                        borderRadius: 2
                                      }}>
                                        <CardContent sx={{ p: 2 }}>
                                          <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                              <InfoItem label="Name" value={remark.name} />
                                              <InfoItem label="Type" value={remark.type} />
                                              <InfoItem label="Pond Location" value={remark.pondLocation} />
                                              <InfoItem label="Category" value={remark.prospectFarmerCategory} />
                                              <InfoItem label="District" value={remark.district} />
                                              <InfoItem label="Current Feed Used" value={remark.currentFeedUsed} />
                                              <InfoItem label="Fish Species" value={remark.fishSpecies} />
                                              <InfoItem label="Number of Ponds" value={remark.numberOfPonds} />
                                              <InfoItem label="Area of Ponds (acres)" value={remark.pondAreaInAcres} />
                                              <InfoItem label="Stocking (Yes/No)" value={remark.isStocking} />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                              <InfoItem label="Stocking Density" value={remark.stockingDensity} />
                                              <InfoItem label="Days of Culture" value={remark.daysOfCulture} />
                                              <InfoItem label="Harvesting (Yes/No)" value={remark.isHarvesting} />
                                              <InfoItem label="Harvesting Quantity" value={remark.harvestingQuantity} />
                                              <InfoItem label="Potential (MT)" value={remark.potentialityInMT} />
                                              <InfoItem label="Status" value={remark.status} />
                                              <InfoItem label="Purpose" value={remark.purpose} />
                                              <InfoItem label="Agent Remarks" value={remark.agentRemarks} />
                                              <InfoItem label="Call Type" value={remark.callType} />
                                              <InfoItem
                                                label="FollowUp Date"
                                                value={remark.followUpDate ? moment(remark.followUpDate).format("DD-MM-YYYY HH:mm:ss") : "-"}
                                              />
                                              <InfoItem
                                                label="Created At"
                                                value={remark.createdAt ? moment(remark.createdAt).format("DD-MM-YYYY HH:mm:ss") : "-"}
                                              />
                                            </Grid>
                                          </Grid>
                                        </CardContent>
                                      </Card>
                                    ))}
                                  </Box>
                                ) : (
                                  <Box sx={{
                                    textAlign: 'center',
                                    py: 3,
                                    color: 'text.secondary',
                                    backgroundColor: 'grey.50',
                                    borderRadius: 2,
                                    border: '1px dashed',
                                    borderColor: 'grey.300'
                                  }}>
                                    <CommentIcon sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
                                    <Typography variant="body1">No feed remarks available</Typography>
                                  </Box>
                                )}
                              </CardContent>
                            </Card>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10} align="center" sx={{ py: 6 }}>
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      color: 'text.secondary'
                    }}>
                      <PhoneCallbackIcon sx={{ fontSize: 64, mb: 2, opacity: 0.3, color: 'success.main' }} />
                      <Typography variant="h6" sx={{ mb: 1 }}>No Outgoing Connected Calls</Typography>
                      <Typography variant="body2">There are no outgoing connected calls to display for the selected period.</Typography>
                      {(mobileFilter || stateFilter) && (
                        <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                          Try adjusting your filters to see more results.
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'grey.50'
          }}
        />
      </Paper>
    </>
  );
}

export default ConnectedCallTable;